<template>
    <div class="container">
        <div class="row">
            <div class="col-sm">
                <div class="box-bordered p-l-10 p-r-10 p-b-10">
                    <table class="table table-hover table-staff">
                        <tbody>
                            <template v-for="area in areas">
                                <tr class="area">
                                    <td :bgcolor="areaColors[area.area_name]" colspan="3">Dział:{{area.area_name}} ({{area.users.length}})</td>
                                </tr>
                                <tr class="staff" v-for="user in area.users">
                                    <td>{{ user.surname }}</td>
                                    <td>{{ user.name }}</td>
                                    <td><a :href="'mailto:' + user.login + '@lekseek.com'">{{ user.login }}@lekseek.com</a></td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {backend} from "../../backend.js";
    import Vue from 'vue';
    import Vuesax from 'vuesax';

    Vue.use(Vuesax);

    export default {
        name: "ActiveEmployees",
        data: function () {
            return {
                areas: [],
                areaColors: [],
                visible: true
            }
        },
        created() {
            backend.getColors()
                .then((response) => {
                    this.areaColors = response.data.area;
                })
                .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać kolorów', color: 'danger'});
                    });
            this.showAreas()
                .then(() => this.visible = true);
        },
        methods: {
            showAreas: function() {
                return backend.getActiveUsersByArea()
                    .then(response => {
                        this.areas = response.data;
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy pracowników', color: 'danger'});
                    });
            },
        },

    }
</script>

<style lang="scss" scoped>
.table-staff {
    th {
        border-top:0;
        padding: 2px 5px;
    }
    tr td {
        border-top: 1px solid #b7b7b7;
        padding: 2px 5px;
    }
    .area {
        text-align: center;
        font-size: 1.8rem;
    }
    .staff {
        background: rgba(255, 255, 255, 1.0);
        &:hover {
            background: darken( rgba(232, 255, 223, 0.75), 10% );
        }
    }
}
</style>


// WEBPACK FOOTER //
// ActiveEmployees.vue?9db79f08